import { Clock, WebGLRenderer } from "three";

export class Common {
    constructor(props) {
        this.props = props;
        const {left: t, top: i, width: s, height: r} = this.props.wrapper.getBoundingClientRect();
        this.left = t;
        this.top = i;
        this.width = s;
        this.height = r;
        this.aspect = this.width / this.height;
        this.isMobile = false;
        this.breakpoint = 768;
        this.fboWidth = null;
        this.fboHeight = null;
        this.resizeFunc = this.resize.bind(this);
        this.time = 0;
        this.delta = 0;
        this.init();
    }
    init() {
        this.pixelRatio = window.devicePixelRatio;
        this.resize();
        this.renderer = new WebGLRenderer({
            powerPreference: "high-performance",
            antialias: false,
            stencil: false,
            depth: false,
            alpha:true
        });
        this.renderer.autoClear = false;
        this.renderer.setSize(this.width, this.height);
        this.renderer.setClearColor(0);
        this.renderer.setPixelRatio(Math.min(2, window.devicePixelRatio));
        this.updateViewport();
        this.clock = new Clock();
        this.clock.start();
    }
    resize() {
        const {left: e, top: t, width: i, height: s} = this.props.wrapper.getBoundingClientRect();
        // if(this.width == i)return;
        this.left = e;
        this.top = t;
        
        this.width = i;
        this.height = s;
        this.aspect = this.width / this.height;
        this.landscape = this.width > this.height;
        if(this.renderer){
            this.renderer.setSize(this.width, this.height);
            this.updateViewport();
        }
        // this.renderer && (this.renderer.setSize(this.width, this.height),
        // this.updateViewport())
    }
    updateViewport() {
        this.offWidth = this.width * .06;
        this.offHeight = this.height * .06;
        this.renderer.setViewport(-this.offWidth, -this.offHeight, this.width + 2 * this.offWidth, this.height + 2 * this.offHeight);
    }
    update() {
        this.delta = this.clock.getDelta();
        this.time += this.delta;
        // const {left: e, top: t, width: i, height: s} = this.props.wrapper.getBoundingClientRect();
        // this.left = e;
        // this.top = t;
        // this.width = i;
        // this.height = s;
        // console.log("width:",this.width);
    }
}